@if (!config?.csvConfig?.hide) {
  <div class="d-flex flex-column w-100">
    <div class="d-flex ms-3 gap-1">
      {{ config?.displayText || "" }}
      <ra-tooltip [tooltipConfig]="config?.tooltipConfig"></ra-tooltip>
    </div>
    @if (progress > 0 && progress < 100) {
      <mat-progress-bar
        mode="determinate"
        [value]="progress"
      ></mat-progress-bar>
    }
    @if (config?.csvConfig?.paramControls?.config?.length > 0) {
      <ra-json-dynamic-form
        [readOnly]="readOnly"
        (configChanged)="onConfigChanged($event)"
        [uiConfig]="config.csvConfig.paramControls"
        (formValueChange)="onConfigChanged()"
      ></ra-json-dynamic-form>
    }
    @if (loading) {
      <mat-spinner class="ms-3" [diameter]="30"></mat-spinner>
    }
    @if (!loading && formData && !readOnly) {
      <div class="px-3 d-flex w-100">
        @if (isEditable) {
          <div class="d-flex flex-column">
            <div class="d-flex w-100 csv-actions flex-wrap mb-2"></div>
            <div class="mb-2">
              @if (csvActionsError) {
                <span class="error-text">{{ csvActionsError }}</span>
              }
              @if (invalidColumnsError) {
                <span class="error-text">{{ invalidColumnsError }}</span>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (!loading && formData && disableEdit) {
      <div
        class="disclaimer-text"
        [innerHTML]="config?.csvConfig?.csvRowsDisclaimerMsg"
      ></div>
    }
    <div #formEl class="d-flex" [ngStyle]="{ width: getWidth() }">
      @if (!loading && formData) {
        <form [formGroup]="formGroup" class="w-100">
          <div
            formArrayName="data"
            class="ps-3 w-100 overflow-hidden table-parent-div"
          >
            <mat-table [dataSource]="controls" class="w-100 h-100 flex-grow-1">
              @for (
                disCol of displayedColumns;
                track disCol;
                let colIndex = $index
              ) {
                @if (disCol !== "actions") {
                  <ng-container [matColumnDef]="disCol">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="pt-3 ps-2"
                      [ngClass]="{ 'static-col': !isColumnsEditable(disCol) }"
                    >
                      <div>
                        @if (!isColumnsEditable(disCol)) {
                          {{ disCol }}
                        }
                      </div>
                      @if (isColumnsEditable(disCol)) {
                        <div class="d-flex col-header">
                          @if (!readOnly ? !disableEdit : !readOnly) {
                            <i
                              class="col-actions fa fa-trash-alt me-3"
                              (click)="deleteColumn(colIndex)"
                            ></i>
                          }
                          <ng-container
                            *ngTemplateOutlet="
                              columnTemplate;
                              context: {
                                disCol: disCol,
                                colIndex: colIndex,
                                config: config,
                              }
                            "
                          ></ng-container>
                        </div>
                      }
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element; let i = index"
                      class="p-2 edit-btn"
                      [ngClass]="{
                        'py-3': !isRowEditable(i),
                        'static-col-value': !isColumnsEditable(disCol),
                      }"
                      [formGroupName]="i"
                    >
                      @if (!isRowEditable(i)) {
                        <span
                          (click)="
                            (!readOnly ? !disableEdit : !readOnly) &&
                              onEditRow(i)
                          "
                          [ngClass]="{
                            'error-text': element?.get(disCol)?.errors,
                          }"
                          >{{ element.get(disCol)?.value }}</span
                        >
                        @if (element.get(disCol)?.errors) {
                          <div
                            (click)="
                              !element.get(disCol)?.value && onEditRow(i)
                            "
                            class="error-text"
                            [ngClass]="{
                              'non-empty-field': element.get(disCol)?.value,
                            }"
                          >
                            {{
                              config.csvConfig.columnControls[disCol]
                                ?.errorMessages?.[
                                keys(
                                  controls[i]?.get(
                                    config.csvConfig.columnControls[disCol]
                                      .property
                                  )?.errors
                                )?.[0]
                              ] || "Please review the field"
                            }}
                          </div>
                        }
                      }
                      @if (
                        isRowEditable(i) &&
                        config?.csvConfig?.columnControls?.[disCol]
                          ?.uiControlType
                      ) {
                        @switch (
                          config?.csvConfig?.columnControls?.[disCol]
                            ?.uiControlType
                        ) {
                          @case (UIControlType.Text) {
                            <ra-input-control
                              [readOnly]="
                                (readOnly ? readOnly : disableEdit) ||
                                isDisabled(disCol, element)
                              "
                              [ngClass]="
                                config.csvConfig?.columnControls?.[disCol]
                                  ?.class || ''
                              "
                              [form]="getParamsFormGroup()"
                              [parentFormGroup]="controls[i]"
                              [currentConfig]="
                                config.csvConfig.columnControls[disCol]
                              "
                            ></ra-input-control>
                          }
                          @case (UIControlType.Number) {
                            <ra-input-control
                              [readOnly]="
                                (readOnly ? readOnly : disableEdit) ||
                                isDisabled(disCol, element)
                              "
                              [ngClass]="
                                config.csvConfig?.columnControls?.[disCol]
                                  ?.class || ''
                              "
                              [form]="getParamsFormGroup()"
                              [parentFormGroup]="controls[i]"
                              [currentConfig]="
                                config.csvConfig.columnControls[disCol]
                              "
                            ></ra-input-control>
                          }
                          @case (UIControlType.TextArea) {
                            <ra-input-control
                              [readOnly]="
                                (readOnly ? readOnly : disableEdit) ||
                                isDisabled(disCol, element)
                              "
                              [ngClass]="
                                config.csvConfig?.columnControls?.[disCol]
                                  ?.class || ''
                              "
                              [form]="getParamsFormGroup()"
                              [parentFormGroup]="controls[i]"
                              [currentConfig]="
                                config.csvConfig.columnControls[disCol]
                              "
                            ></ra-input-control>
                          }
                          @case (UIControlType.Dropdown) {
                            <ra-dropdown-control
                              [readOnly]="
                                (readOnly ? readOnly : disableEdit) ||
                                isDisabled(disCol, element)
                              "
                              [ngClass]="
                                config.csvConfig?.columnControls?.[disCol]
                                  ?.class || ''
                              "
                              [form]="getParamsFormGroup()"
                              [parentFormGroup]="controls[i]"
                              [currentConfig]="
                                config.csvConfig.columnControls[disCol]
                              "
                              (valueChanged)="
                                onSelectionChange(disCol, element, i)
                              "
                            >
                            </ra-dropdown-control>
                          }
                          @case (UIControlType.Checkbox) {
                            <ra-checkbox-control
                              [readOnly]="
                                (readOnly ? readOnly : disableEdit) ||
                                isDisabled(disCol, element)
                              "
                              [ngClass]="
                                config.csvConfig?.columnControls?.[disCol]
                                  ?.class || ''
                              "
                              [form]="getParamsFormGroup()"
                              [parentFormGroup]="controls[i]"
                              [currentConfig]="
                                config.csvConfig.columnControls[disCol]
                              "
                            >
                            </ra-checkbox-control>
                          }
                          @default {
                            <ra-input-control
                              [readOnly]="
                                (readOnly ? readOnly : disableEdit) ||
                                isDisabled(disCol, element)
                              "
                              [ngClass]="
                                config.csvConfig?.columnControls?.[disCol]
                                  ?.class || ''
                              "
                              [form]="getParamsFormGroup()"
                              [parentFormGroup]="controls[i]"
                              [currentConfig]="
                                config.csvConfig.columnControls[disCol]
                              "
                            ></ra-input-control>
                          }
                        }
                      }
                      @if (
                        isRowEditable(i) &&
                        !config?.csvConfig?.columnControls?.[disCol]
                          ?.uiControlType
                      ) {
                        <ra-input-control
                          [readOnly]="
                            (readOnly ? readOnly : disableEdit) ||
                            isDisabled(disCol, element)
                          "
                          [form]="getParamsFormGroup()"
                          [parentFormGroup]="controls[i]"
                          [currentConfig]="{
                            property: disCol,
                            uiControlType: 'text',
                          }"
                        ></ra-input-control>
                      }
                    </td>
                    <td
                      mat-footer-cell
                      *matFooterCellDef
                      style="border: none"
                    ></td>
                  </ng-container>
                }
              }
              <ng-container matColumnDef="actions">
                <th *matHeaderCellDef class="actions-menu-pinned">
                  @if (
                    !readOnly
                      ? !!config?.csvConfig?.newColumnConfig && !disableEdit
                      : !readOnly
                  ) {
                    <div
                      class="newColumnConfig-{{
                        !!config?.csvConfig?.newColumnConfig
                      }} readonly-{{ !readOnly }} disableEdit-{{
                        !disableEdit
                      }}"
                    >
                      <div
                        mat-header-cell
                        class="add-column-control"
                        [ngClass]="{ hidden: isDropdownHidden }"
                      >
                        <mat-form-field class="add-column-dropdown">
                          <mat-label>Add New Column</mat-label>
                          @switch (
                            config?.csvConfig?.newColumnConfig?.uiControlType
                          ) {
                            @case (UIControlType.Dropdown) {
                              <mat-select
                                #newColumnMatSelect
                                (opened)="
                                  getDropdownValues(
                                    config?.csvConfig?.newColumnConfig
                                  )
                                "
                                (selectionChange)="onColumnSelect($event)"
                              >
                                <mat-option>
                                  <ngx-mat-select-search
                                    placeholderLabel="Search..."
                                    noEntriesFoundLabel="No search results"
                                    [formControl]="filterCtrl"
                                    clearSearchInput="true"
                                    hideClearSearchButton="true"
                                  ></ngx-mat-select-search>
                                </mat-option>
                                @if (config.csvConfig.newColumnConfig.loading) {
                                  <mat-option
                                    class="dropdown-loading pointer-events-none"
                                  >
                                    <mat-spinner [diameter]="25"></mat-spinner>
                                  </mat-option>
                                }
                                @if (
                                  !config.csvConfig.newColumnConfig.loading &&
                                  (config.csvConfig.newColumnConfig?.values
                                    ?.length === 0 ||
                                    !config.csvConfig.newColumnConfig?.values)
                                ) {
                                  <mat-option> No Columns Found </mat-option>
                                }
                                @for (
                                  column of config.csvConfig.newColumnConfig
                                    ?.values | filter: searchTerm : null : true;
                                  track column
                                ) {
                                  <mat-option [value]="column">{{
                                    column
                                  }}</mat-option>
                                }
                              </mat-select>
                            }
                            @default {
                              <input
                                matInput
                                [(ngModel)]="columnName"
                                [ngModelOptions]="{ standalone: true }"
                              />
                            }
                          }
                        </mat-form-field>
                      </div>
                      <div
                        (click)="showDropdown()"
                        [ngClass]="{ hidden: !isDropdownHidden }"
                      >
                        <i
                          class="col-actions-plus fa fa-plus mt-1 me-3 actions-cell actions-menu-pinned"
                        >
                          <span class="add-column-label">Add Column</span></i
                        >
                      </div>
                    </div>
                  }
                </th>
                <td
                  *matCellDef="let element; let i = index"
                  class="actions-icons actions-menu-pinned"
                  [formGroupName]="i"
                >
                  @if (!readOnly ? !disableEdit : !readOnly) {
                    <div>
                      @if (isRowsEditable) {
                        <i
                          class="fa"
                          [ngClass]="{ 'fa-check': isRowEditable(i) }"
                          (click)="onRowEditClick(i, element)"
                        ></i>
                        <i
                          class="fas fa-clone ms-2"
                          (click)="cloneRow(element, i)"
                        ></i>
                        <i
                          class="fa fa-trash-alt ms-2"
                          (click)="deleteRow(i)"
                        ></i>
                      }
                    </div>
                  }
                </td>
                <td *matFooterCellDef class="add-row actions-menu-pinned">
                  @if (!readOnly ? !disableEdit && isEditable : !readOnly) {
                    <div>
                      <i
                        class="col-actions-plus fa fa-plus mt-1 me-3"
                        [ngClass]="{ disabled: !hasDataColumns() }"
                      >
                        <span
                          class="add-row-label"
                          (click)="hasDataColumns() && addRow()"
                          >Add Row</span
                        >
                      </i>
                    </div>
                  }
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns; let i = index"
              ></tr>
              <tr
                mat-footer-row
                *matFooterRowDef="displayedColumns; sticky: true"
              ></tr>
            </mat-table>
            <div
              class="d-flex align-items-center"
              [ngClass]="
                errorMessage || notSelectedError || uploadError
                  ? 'justify-content-between'
                  : 'justify-content-end'
              "
            >
              <div>
                @if (errorMessage) {
                  <mat-error class="custom-mat-error p-2">{{
                    errorMessage
                  }}</mat-error>
                }
                @if (notSelectedError && !errorMessage) {
                  <mat-error class="custom-mat-error p-2">{{
                    notSelectedError
                  }}</mat-error>
                }
                @if (uploadError) {
                  <mat-error class="custom-mat-error p-2">{{
                    uploadError
                  }}</mat-error>
                }
              </div>
            </div>
            @if (controls.length > 0) {
              <mat-paginator
                [pageSize]="defaultPageSize"
                [showFirstLastButtons]="showFirstLastButtons"
                [pageSizeOptions]="pageOptions"
                aria-label="Select page"
              ></mat-paginator>
            }
          </div>
          @if (isEditable) {
            <div class="d-flex">
              @if (config?.csvConfig?.info) {
                <span class="py-2 info"
                  ><i class="fa fa-info-circle px-2 d-inline-block"></i
                  >{{ config?.csvConfig?.info }}</span
                >
              }
              <div
                class="d-flex flex-grow-1 justify-content-end align-items-center"
              >
                @if (uploading) {
                  <mat-spinner class="mt-2 me-3" [diameter]="25"
                    >Updating</mat-spinner
                  >
                }
                @if (_isEditable && !readOnly) {
                  <button
                    id="update-btn"
                    class="mt-2 ra-blue-btn mat-mdc-raised-button"
                    [disabled]="
                      uploadError || uploading || isSaveButtonDisabled()
                    "
                    (click)="updateCSV()"
                  >
                    {{ config?.csvConfig?.uploadBtnText || "Save" }}
                  </button>
                }
              </div>
            </div>
          }
        </form>
      }
    </div>
  </div>
}

<ng-template
  #columnTemplate
  let-disCol="disCol"
  let-colIndex="colIndex"
  let-config="config"
>
  <div
    class="add-column-control"
    [ngClass]="{ hidden: isColumnNameChangeDropdownHidden?.[colIndex] ?? true }"
  >
    <mat-form-field class="add-column-dropdown">
      <mat-label>Change Column Name</mat-label>
      @switch (config?.csvConfig?.newColumnConfig?.uiControlType) {
        @case (UIControlType.Dropdown) {
          <mat-select
            #columnNameMatSelect
            (opened)="getDropdownValues(config?.csvConfig?.newColumnConfig)"
            id="columnNameMatSelect{{ colIndex }}{{ id }}"
            (selectionChange)="onColumnNameChange($event, disCol, colIndex)"
          >
            <mat-option>
              <ngx-mat-select-search
                placeholderLabel="Search..."
                noEntriesFoundLabel="No search results"
                [formControl]="filterCtrl"
                clearSearchInput="true"
                hideClearSearchButton="true"
              ></ngx-mat-select-search>
            </mat-option>
            @if (config.csvConfig.newColumnConfig.loading) {
              <mat-option class="dropdown-loading pointer-events-none">
                <mat-spinner [diameter]="25"></mat-spinner>
              </mat-option>
            }
            @if (
              !config.csvConfig.newColumnConfig.loading &&
              (config.csvConfig.newColumnConfig?.values?.length === 0 ||
                !config.csvConfig.newColumnConfig?.values)
            ) {
              <mat-option> No Columns Found </mat-option>
            }
            @for (
              column of config.csvConfig.newColumnConfig?.values
                | filter: searchTerm : null : true;
              track column
            ) {
              <mat-option [value]="column">{{ column }}</mat-option>
            }
          </mat-select>
        }
        @default {
          <input
            matInput
            [(ngModel)]="columnName"
            [ngModelOptions]="{ standalone: true }"
          />
        }
      }
    </mat-form-field>
  </div>
  <div
    (click)="
      (!readOnly ? !disableEdit : !readOnly) &&
        showColumnNameChangeDropdown(colIndex)
    "
    [ngClass]="{
      hidden: !(isColumnNameChangeDropdownHidden?.[colIndex] ?? true),
    }"
  >
    <span
      class="change-column-menu"
      [ngStyle]="{ cursor: readOnly ? 'default' : 'pointer' }"
      >{{ disCol }}</span
    >
  </div>
</ng-template>
